import axios from 'axios';
import envService from "@/services/env.service";

const BASE_URL = envService.getApiBaseUrl() + '/sms/statistics';

export default {

    getSmsCountry(webId, status, from, to) {
        const params = {
            'status': status + "",
            'from': from,
            'to': to
        }
        return axios.get(BASE_URL + '/' + webId + '/country', {
            params: params
        });
    },
    getTopPhoneNumbers(webId, countryCode, status, from, to, limit) {
        const params = {
            'status': status + "",
            'from': from,
            'to': to,
            'limit': limit
        }
        return axios.get(BASE_URL + '/' + webId + '/country/' + countryCode + '/topphonenumbers', {
            params: params
        });
    }


}
